import { createGlobalStyle } from 'styled-components';

import { focusOutline } from './focus-outline.style';

export const GlobalStyles = createGlobalStyle`
  @media (hover: none) {
    * {
      -webkit-tap-highlight-color: transparent;
      outline: none;
    }
  }
  
  * {
    outline-color: ${({ theme }) => theme.palette.divider};
  }

  a:focus-visible,
  button:focus-visible,
  select:focus-visible,
  [tabindex]:not([tabindex="-1"]):focus-visible {
    ${focusOutline};
  }

  html {
    color-scheme: ${({ theme }) => theme.colorScheme};
    overflow: hidden;
  }
  
  body {
    line-height: unset;
    background: ${({ theme }) => theme.palette.background.paper};
  }
`;
